( function( global, $, moment ) {
    "use strict";

    $('body').on('app.init', function(ev) {
        var $container = $(ev.container);
        var defaultOptions = {
            language: "fr",
            weekStart: 7,
            autoclose: true,
            todayHighlight: true,
            clearBtn: true,
            format: 'dd/mm/yyyy'
        };

        $container.find('[datepicker-default]').datepicker(defaultOptions);

        $container.find('[datepicker-required]').datepicker($.extend(defaultOptions, {
            clearBtn: false
        }));

        $container.find('[datepicker-multidate]').datepicker($.extend(defaultOptions, {
            multidate: true,
            multidateSeparator: ', ',
            format: 'd MM yyyy'
        }));
    });

}( window.groots, jQuery, require('moment') ));
